<div
  class="userlist__completeness-filter"
  role="group"
  [attr.aria-label]="'userlist.completeness.label' | translate"
>
  <span class="userlist__completeness-filter-label">{{
    'userlist.completeness.label' | translate
  }}</span>

  <div class="userlist__completeness-filter-chips">
    @for (level of levels; track level) {
      <button
        type="button"
        class="userlist__completeness-chip"
        [class.userlist__completeness-chip--on]="isActive(level)"
        [class.userlist__completeness-chip--complete]="level === 'complete'"
        [class.userlist__completeness-chip--few]="level === 'few'"
        [class.userlist__completeness-chip--many]="level === 'many'"
        [attr.aria-pressed]="isActive(level)"
        (click)="toggle(level)"
      >
        <span
          class="userlist__completeness-chip-dot"
          [class.userlist__completeness-chip-dot--complete]="
            level === 'complete'
          "
          [class.userlist__completeness-chip-dot--few]="level === 'few'"
          [class.userlist__completeness-chip-dot--many]="level === 'many'"
        ></span>
        {{ levelLabelKey(level) | translate }}
        <span class="userlist__completeness-chip-count">{{
          counts[level]
        }}</span>
      </button>
    }
  </div>

  <p class="userlist__completeness-filter-rule">
    {{ 'userlist.completeness.rule' | translate }}
  </p>

  @if (selected.length > 0) {
    <button
      type="button"
      class="userlist__completeness-filter-reset"
      (click)="reset()"
    >
      {{ 'userlist.completeness.reset' | translate }}
    </button>
  }
</div>
